<template>
    <div class='admin-top-bar'>
        <div class='title'>{{page_title}}</div>
        <div class='right-side'>
            <div>
                <div class='name'>{{admin_user_info.full_name}}</div>
                <div class='role'>{{admin_user_info.user_type_text}}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['admin_user_info', 'page_title'],
}
</script>

<style lang='scss' scoped>
.admin-top-bar{
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.title{
    font-size: 2rem;
    font-weight: 500;
    margin-left: 20px;
    color: var(--primary-variant-1);
}

.right-side{
    display: flex;
    gap: 10px;
    margin-right: 20px;
}

.name{
 color: var(--primary-variant-1)
}

.role{
    color: var(--primary-variant-1);
    font-size: 0.8rem;
}

</style>